/**  ai创作 */
export const ai = [
  {
    name: 'getAIMenu', // 获取ai创作配置项
    isMock: false,
  },
  {
    name: 'getAIArtWork', // ai创作详情
    isMock: false,
  },
]
